import { graphql } from '@/graphql';

export const imagesByLayerQuery = graphql(`
  query images($layerIds: [ID!]!) {
    imagesByLayer(layerIds: $layerIds) {
      id
      organizationId
      projectId
      attachmentId
      layerId
      locationWGS84
      location

      groupId
      width
      height
      pixelWidth
      pixelHeight
      focalLengthX
      focalLengthY
      principalPointX
      principalPointY
      rotationMatrix
      rotationQuaternion
      filename
      cameraType
      k1
      k2
      k3
      k4
      p1
      p2
      hasCompressedVariants
      smallFilename
      largeFilename
      hasBlurredVariants
      blurredFilename
      smallBlurredFilename
      largeBlurredFilename

      createdAt
      updatedAt
    }
  }
`);

/** Whole image layers in compact form; expand with `expandImageLayerPack` (via `fetchImageLayers`). */
export const imageLayerPackQuery = graphql(`
  query imageLayerPack($layerIds: [ID!]!) {
    imageLayerPack(layerIds: $layerIds)
  }
`);
